export default "__VITE_ASSET__BHOORq$3__"